import { render, staticRenderFns } from "./CalorieCard.vue?vue&type=template&id=d2aaba24&"
import script from "./CalorieCard.vue?vue&type=script&lang=js&"
export * from "./CalorieCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports